// add links to end of ubermenu

$(document).ready(function() {
  var listItem1 = '<li class="ubermenu-item"><a class="ubermenu-target" href="/basket/" title="Basket"><img class="basket" src="/wp/wp-content/themes/Besponsive10/assets/images/basket-wht.svg" width="15"  /></a></li>';
  var listItem2 = '<li class="ubermenu-item"><button class="mybutton ubermenu-target" data-open="Modal1"><img class="magnifier" src="/wp/wp-content/themes/Besponsive10/assets/images/search.svg" width="16"  /></button></li>';

  $('#ubermenu-nav-main-185').append(listItem1, listItem2);
});

jQuery(document).ready(function($){
    if ($('body').hasClass('single-product')) {
        $('.cart').insertAfter('.product_title');
    }
});


document.addEventListener("DOMContentLoaded", function() {

    var productGallery = document.querySelector('.woocommerce-product-gallery');

    if (productGallery) {
      var wrapper = document.createElement('div');
      wrapper.id = 'video';

      productGallery.parentNode.insertBefore(wrapper, productGallery);
      wrapper.appendChild(productGallery);
    }

});

document.addEventListener("DOMContentLoaded", function() {
    var checkExist = setInterval(function() {
       if (document.querySelector('.slick-slider.slick-initialized')) {
          clearInterval(checkExist);

          var viscoseVideo = document.querySelector('#viscose-video');
          var video = document.querySelector('#video');

          if (viscoseVideo && video) {
              video.appendChild(viscoseVideo);
              viscoseVideo.style.display = "block";  // Show the #viscose-video element
          }
       }
    }, 100); // check every 100ms
});





jQuery(document).ready(function($){
    if($('body').hasClass('postid-12202')) {
        $('.variations_form').append('<p class="quantity-text"><br>Quantity is in thousands, therefore 1 = 1,000.</p><p class="quantity-text">Min order 1,000, max order 15,000.</p>');
    }
});





